import React from 'react';
import { Link } from 'react-router-dom';

const VisitorParking = () => (
  <div id="content">

    <div className="container-fluid bg-dark-steel-grey" id="cvy-hero-1">
      <div className="container">
        <div className="row content-block double-padding quadruple-padding">
          <div className="col-xs-10 col-xs-push-1 col-sm-12 col-sm-push-0 text-center">
            <img src="/static/images/business/icons-cta/cta-clients-visit-you@2x.png" alt="" id="icon-cta-clients-visit-you" />
            <h2 className="collapse-gap">Make It Easy For Clients To <strong>Visit You</strong></h2>
            <p className="callout">Send your visitors reserved parking in advance</p>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-red">
      <div className="container">
        <div className="row content-block half-padding">
          <div className="text-center">
            <h2 className="collapse-gap capitalize">Easy For You</h2>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-off-white client-icon-blocks equalizer-watch">
      <div className="container">
        <div className="row content-block">
          <div className="col-xs-10 col-xs-push-1">
            <div className="row">
              <div className="col-xs-12 col-sm-5 text-center equalizer">
                <img src="/static/images/business/icons/icon-money-pin@2x.png" alt="" id="icon-money-pin" />
                <h4 className="red">Choose Parking</h4>
                <p>You decide when and where your visitors park, and the amount of credit you wish to send. Whether at your office, an event or the airport, we have you covered.</p>
              </div>
              <div className="col-xs-12 col-sm-2 text-center">
                <hr className="equalizer" />
              </div>
              <div className="col-xs-12 col-sm-5 text-center equalizer">
                <img src="/static/images/business/icons/icon-send-email@2x.png" alt="" id="icon-send-email" />
                <h4 className="red">Send Parking</h4>
                <p>Customize your client's parking reservation with directions to your building, floor, and suite. Your details are saved to easily send the same reservation to multiple visitors.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-red">
      <div className="container">
        <div className="row content-block half-padding">
          <div className="text-center">
            <h2 className="collapse-gap capitalize">Easy For Your Clients</h2>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-off-white client-icon-blocks equalizer-watch">
      <div className="container">
        <div className="row content-block">
          <div className="col-xs-10 col-xs-push-1">
            <div className="row">
              <div className="col-xs-12 col-sm-5 text-center equalizer">
                <img src="/static/images/business/icons/icon-mail-received@2x.png" alt="" id="icon-mail-received" />
                <h4 className="red">Receive Your Reservation</h4>
                <p>You've taken care of parking for them. Visitors receive an email with their parking reservation and confirm with one click. No log in or sign up needed.</p>
              </div>
              <div className="col-xs-12 col-sm-2 text-center">
                <hr className="equalizer" />
              </div>
              <div className="col-xs-12 col-sm-5 text-center equalizer">
                <img src="/static/images/business/icons/icon-mobile-pin@2x.png" alt="" id="icon-mobile-pin" />
                <h4 className="red">Get Directions</h4>
                <p>All your visitors get directions directly to their spot without the hassle of searching for or validating parking. Get them there without a hitch.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-dark-steel-grey" id="cvy-hero-2">
      <div className="container">
        <div className="row content-block double-padding">
          <div className="col-xs-10 col-xs-push-1 col-sm-6 col-sm-push-3 text-center">
            <div className="row">
              <img src="/static/images/business/icons/icon-headset@2x.png" alt="" id="icon-headset" />
              <p className="callout">From booking to parking and beyond, our customer service team is available by <a href="mailto:help@parkwhiz.com">email</a> and by phone at <a href="tel:888-472-7594">(888) 472-7594</a>.</p>
            </div>
            <div className="blue-link" />
            <div className="row">
              <img src="/static/images/business/icons/icon-laptop-user@2x.png" alt="" id="icon-laptop-user" />
              <p className="callout">We save you time and money by storing the information you need in one place. All the features you want with none of the clutter.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="container-fluid bg-off-white equalizer-watch">
      <div className="container">
        <div className="row content-block">
          <div className="col-xs-10 col-xs-push-1 text-center">
            <div className="row">
              <div className="col-xs-12 col-sm-6">
                <div className="rounded bg-white">
                  <div className="equalizer">
                    <img src="/static/images/business/icons-cta/cta-visit-your-clients@2x.png" id="icon-cta-visit-your-clients" alt="" />
                    <h3 className="blue">Go Visit Your Clients</h3>
                    <p>Save time visiting your clients by booking parking in advance</p>
                  </div>
                  <Link to={{ pathname: '/business/visit-your-clients' }} className="button">Learn More</Link>
                </div>
              </div>
              <div className="col-xs-12 col-sm-6">
                <div className="rounded bg-white">
                  <div className="equalizer">
                    <img src="/static/images/business/icons-cta/cta-faq@2x.png" id="icon-cta-faq" alt="" />
                    <h3 className="blue">Get All The FAQ<span className="lowercase">s</span></h3>
                    <p>Have more questions about our business solutions? We have answers.</p>
                  </div>
                  <Link to={{ pathname: '/business/faq' }} className="button">Visit FAQ<span className="lowercase">s</span></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default VisitorParking;
